// extracted by mini-css-extract-plugin
export default {"input":"Input_input__N66jg","checked":"Input_checked__ym48H","darkMode":"Input_darkMode__IGcCD","checkbox":"Input_checkbox__zo5c7","close":"Input_close__Y3Caa"};